/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PosOffersDeliveryDtoNG } from "./PosOffersDeliveryDtoNG";
import type { SelectedOffersDTO } from "./SelectedOffersDTO";
import type { StandingInstructionDto } from "./StandingInstructionDto";

export type PosSubmitOfferRequestDtoNG = {
  accountNumber: string;
  debitTransactionId?: string;
  delivery: PosOffersDeliveryDtoNG;
  mcc?: string;
  merchantEmail?: string;
  paymentMethod: PosSubmitOfferRequestDtoNG.paymentMethod;
  paymentOption: PosSubmitOfferRequestDtoNG.paymentOption;
  selectedOffers: Array<SelectedOffersDTO>;
  siPayload?: StandingInstructionDto;
};

export namespace PosSubmitOfferRequestDtoNG {
  export enum paymentMethod {
    BANK_TRANSFER = "BANK_TRANSFER",
  }

  export enum paymentOption {
    MONTHLY_FEE = "MONTHLY_FEE",
    TRANSACTION_FEE = "TRANSACTION_FEE",
    FULL_PAYMENT = "FULL_PAYMENT",
  }
}
